import { useMemo, useState } from 'react';
import type { Chat } from '@trinity/chat';
import { CurrentSegmentIdsContext } from '@trinity/chat-components/containers/Segmentation.Dashboard/context';
import { widgetMetricCardToQuickChartData } from '../../utils/widget-chart';
import { ChartViewContext } from '../Chat/context';
import { WidgetChartView } from './WidgetChartView';

type Props = {
  attachment: Chat.Attachment.WidgetMetricCard;
  projectId: number;
};

export function WidgetMetricCardContainer({ attachment, projectId }: Props) {
  const kpi = useMemo(() => widgetMetricCardToQuickChartData(attachment), [attachment]);
  const chartView = useState<'chart' | 'table'>('chart');
  const segmentIds = useMemo(
    () => ({ projectId, segmentId: 0, projectParentId: 0, slug: '' }),
    [projectId],
  );

  return (
    <ChartViewContext.Provider value={chartView}>
      <CurrentSegmentIdsContext.Provider value={segmentIds}>
        <WidgetChartView kpi={kpi} title={kpi.title} />
      </CurrentSegmentIdsContext.Provider>
    </ChartViewContext.Provider>
  );
}

WidgetMetricCardContainer.displayName = 'Chat.Attachments.WidgetMetricCardContainer';
